import { otherApiClient } from ".";
export const getGnbMenu = async (params)=>{
    const { data  } = await otherApiClient.market.get("/home/routing", {
        params
    });
    return data;
};
export const getHomeDetail = async (params)=>{
    const { homeId , ipSelectSourceId  } = params;
    const { data  } = await otherApiClient.market.get("/home/".concat(homeId), {
        params: ipSelectSourceId ? {
            ipSelectSourceId
        } : undefined
    });
    return data;
};
export const getHomeIpSelect = async (params)=>{
    const { data  } = await otherApiClient.market.get("/home/".concat(params.homeId, "/ip-sections"), {
        params
    });
    return data;
};
export const getBrandPreview = async (id)=>{
    const { data  } = await otherApiClient.market.get("/brand-preview/".concat(id));
    return data;
};
